import Backbone from 'backbone'
import DatasetsDisplayHeader from '../datasets-display-header'
import tabs from './../datasets-tabs.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import DatasetBuilding from 'scoreboard/datasets/not-available/dataset-building'
import Dataset from 'scoreboard/datasets/model/dataset'
import datasetStatus from './dataset-status'

var DatasetNotReady = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	className: 'display-layout table-hack dataset-not-ready',

	/**
	 *
	 * @param {Object} options
	 * @param {'overview'|'records'|null} options.subsection the subsection of the dataset's tab we're showing
	 * @param {Boolean=true} options.useLinkedDatasetProgress Whether or not to derive the dataset's
	 * 			building progress based on just the dataset itself or it's linked datasets too.
	 * @param {Boolean=false} options.forceNotReadyView If true, ignore the dataset's status and
	 * building progress and show the building animation no matter what in {@link #finishedBuildingAndDisplayable}
	 *
	 */
	initialize: function(options) {
		_.defaults(options, {
			useLinkedDatasetProgress: true,
			forceNotReadyView: false
		})
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().addClass('empty-display')

		if (!this.options.noHeader) {
			this.header = new DatasetsDisplayHeader({
				heading: this.model.get('label'),
				model: this.model,
				subsection: this.options.subsection,
				tabs: tabs({
					id: this.model.id,
					section: 'datasets'
				})
			})
			this.$el.append(this.header.el)
			this.header.render()
		}

		this.datasetBuilding = new DatasetBuilding({
			isQuickset: this.options.isQuickset,
			model: this.model,
			queryError: this.options.queryError,
			triggerReadyEvent: this.options.forceNotReadyView
		})
		this.$el.append(this.datasetBuilding.el)
		this.datasetBuilding.render()
		this.datasetBuilding.init()
		this.datasetBuilding.on('ready', ({progress, status}) =>
			this.displayDatasetAfterBuildFinished(progress, status))

		// #32080 if a queryError was passed in options, it overrides the dataset's status,
		// so don't update the status, progress, or animation
		if (!this.options.queryError) {
			this.getProgress().then(statusForDataset => {
				// #49051 #49725 if we can't find the dataset info, we certainly
				// won't be updating any animations, so we can fail silently
				if (!statusForDataset) return

				let {id, status, progress, label} = statusForDataset
				if (status === Dataset.STALE && progress > 0) {
					// A server-side dataset will be stale until it's complete.
					// We have to consider the websocket updates, but if the page was loaded
					// between updates we read the progress instead to derive that is in fact loading
					status = Dataset.LOADING
				} else if (_.isEmpty(status)) {
					// Shows the empty loading svg. When a status is pushed to the websocket
					// the datasetBuilding state will be updated. Fixes #19661.
					status = Dataset.AWAITING_RESPONSE
				}
				this.updateAnimation(id, status, progress, label)
			})
		}

		// don't show a calendar period selector
		this.$('.period-display.tab').remove()

		const assignProgress = props => {
			if (props) {
				this.getProgress().then(statusForDataset => {
					const {id, status, progress, label} = statusForDataset
					this.updateAnimation(id, status, progress, label)
				})
			}
		}

		datasetStatus().then(status => {
			const {rootId} = this.model.attributes

			// Apply most recently pushed status update
			// Prevents race condition where push is received before we get here
			assignProgress(status.get(rootId))

			this.listenTo(status, 'change', props => {
				if (props.id === this.model.id && !_.isEmpty(props.numTracked)) {
					this.model.set('numTracked', props.numTracked)
				}

				// detect progress update on dataset or any linked dataset
				const changedRootId = props.id
				if (_.find(this.model.datasetsById, c => c.get('rootDatasetId') == changedRootId)) {
					assignProgress(props)
				}
			})
		})

		return this
	},

	getProgress: function() {
		if (this.options.useLinkedDatasetProgress) {
			return this.model.getLowestProgress()
		}

		return datasetStatus().then(status => this.model.getProgressFromStatus(status, this.model))
	},

	// Sets the "Building Dataset" progress bar or dismisses it based on the
	// given dataset loading progress
	updateAnimation: function(id, status, progress, linkedDatasetLabel) {
		// Set the datasetBuilding to the given status and, when that's done, perform
		// steps to wrap things up if the progress is at 100%
		this.datasetBuilding.setState(status)
		this.datasetBuilding.setProgress(progress, linkedDatasetLabel && i18n.get('datasets.waiting', '<a class="sp-navigate" href="/datasets/' + id + '">' + _.escape(linkedDatasetLabel) + '</a>'))
		this.maybeDisplayDataset(progress, status)
	},

	maybeDisplayDataset: function(progress, status) {
		if (this.options.forceNotReadyView || !this.model.isDisplayable()) return

		this._displayReadyDataset(progress, status)
	},

	displayDatasetAfterBuildFinished: function(progress, status) {
		this._displayReadyDataset(progress, status)
	},

	_displayReadyDataset: function(progress, status) {
		const finishedBuildingAndDisplayable = progress >= 1 && this.model.isComplete(status)
		if (finishedBuildingAndDisplayable) {
			this.trigger('ready', { dataset: this.model, status })
			this.$('.empty-state-message').addClass('fade')
		}
	},

	unsubscribe: function() {
		_.invoke(this.subscription, 'unsubscribe')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.header, this.datasetBuilding], 'remove')
	}

})

export default DatasetNotReady

DatasetNotReady.__filename__ = 'datasets/not-available/dataset-not-ready.js'
